import { useCallback, useEffect, useState } from "react";
import fetchData from "../../../../APIsControll/apiControll";

export function useItemSearch(warehouseId, managerId) {
  const [keyword, setKeyword] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const fetchItems = useCallback(
    async (kw) => {
      if (!kw.trim()) {
        setResults([]);
        return;
      }
      const apiData = {
        managerId: managerId,
        keyword: kw,
        warehouseId: warehouseId,
      };
      try {
        setLoading(true);
        const result = await fetchData(
          "production/searchProductionItems",
          apiData,
        );

        if (result.status === "success") {
          setResults(result.data || []);
          setCurrentIndex(0);
        }
      } catch {
        setResults([]);
      } finally {
        setLoading(false);
      }
    },

    [warehouseId, managerId],
  );

  useEffect(() => {
    const t = setTimeout(() => {
      fetchItems(keyword);
    }, 300);

    return () => clearTimeout(t);
  }, [keyword, warehouseId, fetchItems]);

  return {
    keyword,
    setKeyword,
    results,
    setResults,
    loading,
    currentIndex,
    setCurrentIndex,
  };
}
